<template>
  <transition
    name="lm-modal-tour-transition"
    @after-enter="opened"
    @after-leave="closed"
    @leave-cancelled="closed"
  >
    <div
      v-show="show"
      class="fixed inset-0 z-modal flex-center bg-backdrop"
      @keydown.esc="close()"
      @mousedown.self="close()"
    >
      <div class="Wrapper">
        <lm-icon-button
          icon="close"
          svg
          svg-white
          class="absolute right-0 mt-5 mr-5"
          @click="close()"
        />
        <div class="Header">
          <img :src="data[currentStep - 1].img" />
        </div>
        <div class="min-h-48 flex flex-col py-5 px-4 desktop:px-10 bg-white">
          <div v-if="steps > 1" class="mb-6 mx-auto flex">
            <step-indicator
              v-for="(step, index) in steps"
              :id="index + 1"
              :key="`si${step}${index}`"
              :steps="steps"
              :current-step="currentStep"
              onboarding-theme
            />
          </div>
          <h1 class="mb-2 text-l text-gray-700 text-center">
            {{ data[currentStep - 1].title }}
          </h1>
          <p
            class="text-gray-500 text-center"
            v-html="data[currentStep - 1].description"
          />
          <div class="flex justify-between mt-auto">
            <lm-button-next
              label="Back"
              :disabled="currentStep === 1"
              @click="prevStep"
            />
            <lm-button-next
              :label="currentStep === steps ? 'Done' : 'Next'"
              type="accent"
              @click="nextStep"
            />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import StepIndicator from '@/components/modals/form/StepIndicator'
import LmButtonNext from '@/components/ui/button/LmButtonNext'
import LmIconButton from '@/components/ui/LmIconButton'
import {Events, ModalType} from '@/lib/definitions'
import EventHub from '@/lib/eventHub'

export default {
  name: 'LmModalTour',
  components: {StepIndicator, LmButtonNext, LmIconButton},
  props: {
    name: {
      type: String,
      required: true
    },
    data: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      show: false,
      currentStep: 1
    }
  },
  computed: {
    steps() {
      return this.data.length
    }
  },
  mounted() {
    EventHub.on(Events.CLOSE_MODAL, this.doClose) // !?
    this.open()
  },
  methods: {
    open() {
      if (!this.show) {
        this.$emit(Events.BEFORE_OPEN)
        this.show = true
        this.$store.dispatch('hideScrollbar')
      }
    },
    opened() {
      this.$emit(Events.AFTER_OPEN)
    },
    nextStep() {
      if (this.currentStep < this.steps) {
        this.currentStep++
      } else if (this.currentStep === this.steps) {
        this.close()
      }
    },
    prevStep() {
      if (this.currentStep > 1) {
        this.currentStep--
      }
    },
    close() {
      this.$router.removeKeyFromQuery(ModalType.MODAL)
    },
    doClose() {
      this.$emit(Events.BEFORE_CLOSE)
      this.show = false
    },
    closed() {
      this.$emit(Events.AFTER_CLOSE)
      EventHub.removeListener(Events.CLOSE_MODAL, this.doClose)
      EventHub.emit(Events.MODAL_CLOSED, this.name)
      this.$store.dispatch('showScrollbar')
    }
  }
}
</script>

<style scoped>
.Wrapper {
  width: 620px;
  transform: scale(1);
  @apply relative m-4 bg-white shadow-modal rounded-xl rounded-b-none;
  &:focus {
    outline: none;
  }
}
.Header {
  height: 300px;
  @apply flex items-center justify-center bg-white rounded-lg rounded-b-none;
  background: linear-gradient(
      120deg,
      rgba(46, 46, 46, 0.2) 26.42%,
      rgba(0, 0, 0, 0) 68.09%
    ),
    #8b5cf6;
}
/* Transition */
.lm-modal-tour-transition-enter-active {
  transition: opacity 0.5s;
  .Wrapper {
    transition: transform 0.5s;
  }
}
.lm-modal-tour-transition-leave-active {
  transition: opacity 0.3s;
  .Wrapper {
    transition: transform 0.3s;
  }
}
.lm-modal-tour-transition-enter,
.lm-modal-tour-transition-leave-to {
  opacity: 0;
}
.lm-modal-tour-transition-enter .Wrapper {
  transform: scale(0.8);
}
.lm-modal-tour-transition-leave-to .Wrapper {
  transform: scale(1.2);
}
</style>
<style>
.js-focus-visible .Wrapper:focus:not(.focus-visible) {
  outline: none;
}
</style>
